import { Translation } from '@/components/i18n/Translation'

import './success.scss'

const Success = ({ textId, children, ...restOfProps }: any) => (
  <div className="feedback success">
    {textId && <Translation id={textId} {...restOfProps} />}

    {children}
  </div>
)

export default Success
